/* eslint-disable max-classes-per-file */
import { Injectable } from '@angular/core';
import { Location as ngLocation } from '@angular/common';

import { PortalUrlComponents } from 'webcommon/shared';

import { BrowserService } from './BrowserService';

@Injectable({
  providedIn: 'root',
})
export class UrlParsingService {
  static readonly ajsFactoryName = 'UrlParsingService';

  constructor(
    browserService: BrowserService,
  ) {
    this.locationObj = browserService.getLocation();
  }

  private locationObj: Location;

  // We can't currently replace this function to directly use URLSearchParams on location.search
  // because with HashLocationStrategy, the query params are supposed to be part of the fragment;
  // but still in PRM, I think not all the query params are done this way
  // (check MobileBrowserUtil)
  // But we can try to use QueryStringHelper declared below.
  getParameterByName(name: string): string {
    const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    const results = regex.exec(this.locationObj.search);

    return results == null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }

  parsePortalUrl(marker: string): Promise<PortalUrlComponents> {
    const url = this.locationObj.href;
    const markerIndex = url.indexOf(marker);
    const restOfUrlIndex = markerIndex + marker.length;
    if (markerIndex > 0 && restOfUrlIndex < url.length) {
      const hostUrl = url.substring(0, markerIndex);
      const restOfUrl = url.substring(restOfUrlIndex);
      const firstSlashIndex = restOfUrl.indexOf('/');
      if (firstSlashIndex > 0) {
        const clientId = restOfUrl.substring(0, firstSlashIndex);
        const clientConfig = {
          clientId,
          hostUrl,
        };
        return Promise.resolve(clientConfig);
      }
    }
    return Promise.reject();
  }

  getBaseUrl(): string {
    return this.locationObj.origin;
  }
}


export class QueryStringHelper {
  readonly originalPath: string;
  readonly searchParams: URLSearchParams;

  constructor(
    private location: ngLocation,
  ) {
    // With HashLocationStrategy, the query params are part of the fragment (which is in location.path()),
    // not the normal query strings in location.search
    const splitLocation = this.location.path().split('?');
    this.originalPath = splitLocation[0];
    this.searchParams = new URLSearchParams(splitLocation[1]);
  }

  // update the query string without navigating anywhere
  // ex: deleting query strings that have been processed and don't need to be there when reloading
  updateUrl() {
    // IMPORTANT: If changing this logic, make sure it works with different base href
    // ex: ng serve config => "servePath": "/foobar/" and build config => "baseHref": "/foobar/"
    this.location.replaceState(this.originalPath, this.searchParams.toString(), this.location.getState());
  }
}
